var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-move-component" },
    [
      _c(
        "modal",
        {
          ref: "updateMoveInOutModal",
          attrs: {
            modalId: "editMoveModal",
            modalType: "customize-modal",
            className: "medium-modal",
            showCloseBtn: false,
            afterOpenModal: _vm.afterOpenModal,
          },
        },
        [
          _c("div", { attrs: { slot: "modal-header" }, slot: "modal-header" }, [
            _c(
              "span",
              {
                staticClass:
                  "modal-pure-text modal-pure-text--bigger modal-pure-text--label",
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.currentOption.addRecord) +
                    "\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal-content",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "update-move-date input-row input-row--center row",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "modal-pure-text required-flag modal-pure-text--label",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.currentOption.actualDate) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("DatePicker", {
                    ref: "datePicker",
                    attrs: {
                      required: true,
                      calendarButton: true,
                      calendarButtonIcon: "fa fa-calendar",
                      value: _vm.formatDate(_vm.requestParams.date),
                    },
                    on: {
                      selected: function (val) {
                        return _vm.updateDate(val)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "update-bussiness-date input-row input-row--center row",
                },
                [
                  _c(
                    "span",
                    { staticClass: "modal-pure-text modal-pure-text--label" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.currentOption.businessDate) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("DatePicker", {
                    attrs: {
                      calendarButton: true,
                      calendarButtonIcon: "fa fa-calendar",
                      value: _vm.formatDate(_vm.requestParams.businessDate),
                    },
                    on: {
                      selected: function (val) {
                        return _vm.updateBusinessDate(val)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-row" },
                [
                  _c(
                    "span",
                    { staticClass: "modal-pure-text modal-pure-text--label" },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("handover.moveInOut.header.remarks"))
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("TextField", {
                    ref: "remark-textfield",
                    staticClass: "remark-textfield",
                    attrs: {
                      placeholder: _vm.$t(
                        "handover.moveInOut.message.moveInOutRemarkPlaceHolder",
                        [_vm.currentOption.correspondingHotbs]
                      ),
                      value: _vm.requestParams.remark,
                    },
                    on: {
                      updateValue: function (val) {
                        return _vm.updateRemark(val)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "update-hotbs input-row" },
                [
                  _c("label", { staticClass: "modal-pure-text" }, [
                    _vm._v(_vm._s(_vm.currentOption.correspondingHotbs)),
                  ]),
                  _vm._v(" "),
                  _c("HKLMultiSelect", {
                    staticClass: "multi-value",
                    attrs: {
                      value: _vm.moveItemIds,
                      options: _vm.hotbHklOptions,
                      placeholder: "",
                    },
                    on: { change: _vm.onHotbsChange },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "move-detail-table input-row" },
                [
                  _vm.isActive
                    ? _c("CommonTable", {
                        attrs: {
                          needCache: false,
                          tableContentLists: _vm.tableContents,
                          renderHeaderList: _vm.tableHeader,
                          resizeColumnWhenContentChange: false,
                          defaultOrder: false,
                          needFilter: false,
                          tableId: _vm.tableId,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                on: {
                  click: function ($event) {
                    return _vm.close()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                on: {
                  click: function ($event) {
                    return _vm.openConfrimModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.saveAndNotify")))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "saveConfirmModal",
          attrs: { modalId: "save-confirm-modal", showCloseBtn: false },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("div", { staticClass: "confirm-content" }, [
              _c("span", { staticClass: "modal-pure-text" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("handover.moveInOut.message.beforeSaving")) +
                    "\n        "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                on: {
                  click: function ($event) {
                    return _vm.closeConfrimModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                on: {
                  click: function ($event) {
                    return _vm.save()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.ok")))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("HKLModal", {
        ref: "inputRequireModal",
        attrs: {
          zIndex: 1005,
          title: _vm.$t("handover.moveInOut.message.moveInOutInputHint", [
            _vm.currentOption.correspondingHotbs,
          ]),
          hasCancelBtn: false,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }